import { createApiAction, createInfoApiAction, createPaginationAction } from './common'

export const createGym = createApiAction('createGym')
export const getGymList = createPaginationAction('getGymList')
export const getGymDetail = createInfoApiAction('getGymDetail', (id) => ({ id }))
export const updateGymDetail = createInfoApiAction('getGymDetail', (id, data) => ({ id, data }))
export const deleteGym = createApiAction('deleteGym')

